import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import '../../css/EmergencyShutdown.css'; // Import a CSS file for styling
import { useServiceCaller } from '../../services/Ros/ServiceCaller';

const MaintenanceShutdown: React.FC = () => {
  const [isArmed, setIsArmed] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { callService } = useServiceCaller();

  const handleArm = () => {
    setIsArmed(true);
    console.log('Maintenance shutdown armed.');
  };

  const handleShutdown = async () => {
    if (isArmed) {
      console.log('shutdown initiated!');
      // Publish true to the emergency shutdown topic
      const request: any = { data: true }

      const result = await callService(request)
      console.log(result)
      setIsArmed(false); // Reset the armed state after shutdown
      setIsModalOpen(false); // Close the modal after shutdown
    } else {
      console.log('Please arm the shutdown button first.');
    }
  };

  const openModal = () => {
    handleArm();
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsArmed(false);
    setIsModalOpen(false);
  };

  return (
    <div className="emergency-shutdown-container">
      <Button 
        variant='warning' 
        onClick={openModal} 
        disabled={isArmed}
      >
        Maintenance Shutdown
      </Button>

      <Modal show={isModalOpen} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Shutdown</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to initiate the shutdown?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleShutdown}>
            Yes, Shutdown
          </Button>
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default MaintenanceShutdown;
